// @flow
import * as React from "react";
import VimeoPlayer from "@vimeo/player";

type Props = {
  autoplay: boolean,
  id: string
};

export default class VideoPlayer extends React.Component<Props> {
  videoNode: ?HTMLDivElement;
  player: VimeoPlayer;

  componentDidMount() {
    this.player = new VimeoPlayer(this.videoNode, this.props);
    this.player.on("ended", this.openForm);
  }

  openForm() {
    const form = document.getElementById("claims-form");
    if (form) {
      form.classList.remove("invisible");
    }
  }

  render() {
    return <div ref={v => (this.videoNode = v)} className="embed-video" />;
  }
}



// WEBPACK FOOTER //
// ./app/javascript/video_player/index.jsx